// const timeAuctionContractAddress = "0x624bC5cCf85bc024a48F3F38836497fa1EAee6A2" // timed Auction testnet
const timeAuctionContractAddress = "0xbcebf07a4017ea16d7f6adb8343365381b58e98d" // timed Auction Mainnet
export default timeAuctionContractAddress